import { a as i, j as n, F as x } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { useState as g } from "react";
import { Colors as s } from "../../1-foundations/Colors/Colors.js";
import { I as u } from "../../../Icon-BruFLyVl.js";
import "../../../FeatureFlagProvider-DSFeeZ8R.js";
import "@ionic/react";
import "../../../react-paginate-Lh5zQzpz.js";
import "../LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function S(p) {
  const {
    title: a,
    chip: r,
    children: d,
    isOpen: t,
    onToggle: o
  } = p, [c, m] = g(t ?? !1), l = t !== void 0, e = l ? t : c;
  function h() {
    l ? o == null || o() : m((f) => !f);
  }
  return /* @__PURE__ */ i(x, {
    children: [/* @__PURE__ */ n("div", {
      style: {
        padding: "16px 0",
        backgroundColor: s.white200,
        borderBottom: `1px solid ${s.slate300}`
      },
      children: /* @__PURE__ */ i("div", {
        style: {
          padding: "8px 16px",
          display: "flex",
          justifyContent: "space-between"
        },
        children: [/* @__PURE__ */ i("div", {
          style: {
            display: "flex",
            gap: 16,
            alignItems: "center"
          },
          children: [/* @__PURE__ */ n("span", {
            style: {
              fontWeight: 500,
              lineHeight: "24px",
              letterSpacing: "0.15px",
              fontSize: 20
            },
            children: a
          }), r && r]
        }), /* @__PURE__ */ n("button", {
          style: {
            background: "none"
          },
          onClick: h,
          "aria-expanded": e,
          "aria-label": e ? "Collapse section" : "Expand section",
          children: /* @__PURE__ */ n(u, {
            name: e ? "Chevron Down" : "Chevron Up"
          })
        })]
      })
    }), e && d]
  });
}
export {
  S as Accordion
};
